import {
  CREATE_NEW_CAMPAIGN,
  DELETE_CAMPAIGN,
  DELETE_CAMPAIGN_AD,
  DELETE_CAMPAIGN_AD_ERROR,
  DELETE_CAMPAIGN_AD_SUCCESS,
  DELETE_CAMPAIGN_ERROR,
  DELETE_CAMPAIGN_SUCCESS,
  DUPLICATE_ADGROUP,
  DUPLICATE_ADGROUP_ERROR,
  DUPLICATE_ADGROUP_SUCCESS,
  DUPLICATE_CAMPAIGN,
  DUPLICATE_CAMPAIGN_ERROR,
  DUPLICATE_CAMPAIGN_SUCCESS,
  GET_CAMPAIGNS,
  GET_CAMPAIGNS_ERROR,
  GET_CAMPAIGNS_SUCCESS,
  GET_CAMPAIGN_BY_ID,
  GET_CAMPAIGN_BY_ID_ERROR,
  GET_CAMPAIGN_BY_ID_SUCCESS,
  MODIFY_ADGROUP,
  MODIFY_ADGROUP_ERROR,
  MODIFY_ADGROUP_SUCCESS,
  MODIFY_CAMPAIGN,
  MODIFY_CAMPAIGN_ERROR,
  MODIFY_CAMPAIGN_SUCCESS,
  NEW_ADGROUP,
  NEW_ADGROUP_ERROR,
  NEW_ADGROUP_SUCCESS,
  NEW_CAMPAIGN_AD,
  NEW_CAMPAIGN_AD_ERROR,
  NEW_CAMPAIGN_AD_SUCCESS,
  NEW_CAMPAIGN_ERROR,
  NEW_CAMPAIGN_SUCCESS,
  RESET_LAST_COMPLETED_ACTION,
  NEW_ADGROUP_TRACKING,
  NEW_ADGROUP_TRACKING_SUCCESS,
  NEW_ADGROUP_TRACKING_ERROR,
  MODIFY_CAMPAIGN_AD,
  MODIFY_CAMPAIGN_AD_ERROR,
  MODIFY_CAMPAIGN_AD_SUCCESS,
  DELETE_ADGROUP_ERROR,
  DELETE_ADGROUP_SUCCESS,
  DELETE_ADGROUP,
  DELETE_MULTIPLE_CAMPAIGN,
  DELETE_MULTIPLE_CAMPAIGN_ERROR,
  DELETE_MULTIPLE_CAMPAIGN_SUCCESS,
  RESET_COPY_SCHEDULE_TO_ALL_CAMPAIGNS,
  GET_ACCOUNT_CAMPAIGNS,
  GET_ACCOUNT_CAMPAIGNS_SUCCESS,
  GET_ACCOUNT_CAMPAIGNS_ERROR,
  GET_FILTER_VOLUME,
  GET_FILTER_VOLUME_SUCCESS,
  GET_FILTER_VOLUME_ERROR,
  GET_CLICK_CAMPAIGN_STATS,
  GET_CLICK_CAMPAIGN_STATS_SUCCESS,
  GET_CLICK_CAMPAIGN_STATS_ERROR,
  GET_CLICK_CAMPAIGN_STATS_BY_ID,
  GET_CLICK_CAMPAIGN_STATS_BY_ID_SUCCESS,
  GET_CLICK_CAMPAIGN_STATS_BY_ID_ERROR,
  GET_LEAD_CAMPAIGN_STATS,
  GET_LEAD_CAMPAIGN_STATS_SUCCESS,
  GET_LEAD_CAMPAIGN_STATS_ERROR,
  GET_CALL_CAMPAIGN_STATS_BY_ID,
  GET_CALL_CAMPAIGN_STATS_BY_ID_SUCCESS,
  GET_CALL_CAMPAIGN_STATS_ERROR,
  GET_CALL_CAMPAIGN_STATS_BY_ID_ERROR,
  GET_LEAD_CAMPAIGN_STATS_BY_ID_ERROR,
  GET_LEAD_CAMPAIGN_STATS_BY_ID_SUCCESS,
  GET_LEAD_CAMPAIGN_STATS_BY_ID,
  GET_CALL_CAMPAIGN_STATS,
  GET_CALL_CAMPAIGN_STATS_SUCCESS,
  GET_FILTER_PACKAGES,
  GET_FILTER_PACKAGES_SUCCESS,
  GET_FILTER_PACKAGES_ERROR,
  GET_CAMPAIGNS_SOURCE_SETTINGS_ERROR,
  GET_CAMPAIGNS_SOURCE_SETTINGS_SUCCESS,
  GET_CAMPAIGNS_SOURCE_SETTINGS,
  GET_BID_MULTIPLIER_HISTORY,
  GET_BID_MULTIPLIER_HISTORY_SUCCESS,
  GET_BID_MULTIPLIER_HISTORY_ERROR,
  GET_ACTIVE_CAMPAIGNS_FOR_SOURCES,
  GET_ACTIVE_CAMPAIGNS_FOR_SOURCES_SUCCESS,
  GET_ACTIVE_CAMPAIGNS_FOR_SOURCES_ERROR,
  GET_DEFAULT_TRANSFER_NUMBER,
  GET_DEFAULT_TRANSFER_NUMBER_SUCCESS,
  GET_DEFAULT_TRANSFER_NUMBER_ERROR,
  SET_PREVIOUS_LEAD_TYPE_ID,
  GET_AD_GROUP_STATS_V4,
  GET_AD_GROUP_STATS_V4_SUCCESS,
  GET_AD_GROUP_STATS_V4_ERROR,
  GET_AD_GROUP_BID_MULTIPLIER_HISTORY,
  GET_AD_GROUP_BID_MULTIPLIER_HISTORY_SUCCESS,
  GET_AD_GROUP_BID_MULTIPLIER_HISTORY_ERROR,
} from './actionTypes';

// GET_CAMPAIGNS

export const getCampaigns = (payload) => ({
  type: GET_CAMPAIGNS,
  payload,
});

export const getCampaignSuccess = (campaign, time_frame_key) => ({
  type: GET_CAMPAIGNS_SUCCESS,
  payload: campaign,
  time_frame_key,
});

// `failed_request` identifies which request failed — the time frame key plus the range it asked
// for. Without it a failure is anonymous, and a caller cannot tell whether the request that failed
// was its own or another caller's. (BM-9197)
export const getCampaignError = (error, failed_request = null) => ({
  type: GET_CAMPAIGNS_ERROR,
  payload: null,
  error, // TODO: Set error here and parse
  failed_request,
});

// GET_CAMPAIGN_BY_ID

export const getCampaignById = (payload) => ({
  type: GET_CAMPAIGN_BY_ID,
  payload,
});

export const getCampaignByIdSuccess = (campaign, time_frame_key, queryParams, feature_flag) => ({
  type: GET_CAMPAIGN_BY_ID_SUCCESS,
  payload: campaign,
  time_frame_key,
  queryParams,
  feature_flag
});

export const getCampaignByIdError = (error) => ({
  type: GET_CAMPAIGN_BY_ID_ERROR,
  payload: error,
});

// CREATE_NEW_CAMPAIGN

export const createNewCampaign = (campaign, history) => ({
  type: CREATE_NEW_CAMPAIGN,
  payload: { campaign, history },
});

export const newCampaignSuccess = (campaign) => ({
  type: NEW_CAMPAIGN_SUCCESS,
  payload: campaign,
});

export const newCampaignError = (error) => ({
  type: NEW_CAMPAIGN_ERROR,
  payload: error,
});

// MODIFY_CAMPAIGN

export const modifyCampaign = (campaign) => ({
  type: MODIFY_CAMPAIGN,
  payload: campaign,
});

export const duplicateCampaign = (campaign) => ({
  type: DUPLICATE_CAMPAIGN,
  payload: campaign,
});

export const duplicateCampaignSuccess = (campaign) => ({
  type: DUPLICATE_CAMPAIGN_SUCCESS,
  payload: campaign,
});

export const duplicateCampaignError = (campaign) => ({
  type: DUPLICATE_CAMPAIGN_ERROR,
  payload: campaign,
});

export const modifyCampaignSuccess = (campaign) => ({
  type: MODIFY_CAMPAIGN_SUCCESS,
  payload: campaign,
});

export const modifyCampaignError = (error) => ({
  type: MODIFY_CAMPAIGN_ERROR,
  payload: error,
});

// DELETE CAMPAIGN

export const deleteCampaign = (campaign) => ({
  type: DELETE_CAMPAIGN,
  payload: campaign,
});

export const deleteCampaignSuccess = (campaign) => ({
  type: DELETE_CAMPAIGN_SUCCESS,
  payload: campaign,
});

export const deleteCampaignError = (error) => ({
  type: DELETE_CAMPAIGN_ERROR,
  payload: error,
});

//delete multiple campaigns
export const deleteMultipleCampaign = (campaign_ids) => ({
  type: DELETE_MULTIPLE_CAMPAIGN,
  payload: campaign_ids,
});

export const deleteMultipleCampaignSuccess = (campaigns) => ({
  type: DELETE_MULTIPLE_CAMPAIGN_SUCCESS,
  payload: campaigns,
});

export const deleteMultipleCampaignError = (error) => ({
  type: DELETE_MULTIPLE_CAMPAIGN_ERROR,
  payload: error,
});

// Create Adgroup

export const newAdgroup = (adgroup) => ({
  type: NEW_ADGROUP,
  payload: adgroup,
});

export const newAdgroupSuccess = (adgroup) => ({
  type: NEW_ADGROUP_SUCCESS,
  payload: adgroup,
});

export const newAdgroupError = (error) => ({
  type: NEW_ADGROUP_ERROR,
  payload: error,
});

// Modify  Adgroup
export const modifyAdgroup = (adgroup) => ({
  type: MODIFY_ADGROUP,
  payload: adgroup,
});

export const modifyAdgroupSuccess = (payload) => {
  return {
    type: MODIFY_ADGROUP_SUCCESS,
    payload: payload?.adgroup,
    additional_data: payload?.additional_data
  }
};

// Campaign Ad
export const newCampaignAd = (campaign_ad) => ({
  type: NEW_CAMPAIGN_AD,
  payload: campaign_ad,
});
export const newCampaignAdSuccess = (campaign_ad) => ({
  type: NEW_CAMPAIGN_AD_SUCCESS,
  payload: campaign_ad,
});
export const newCampaignAdError = (error) => ({
  type: NEW_CAMPAIGN_AD_ERROR,
  payload: error,
});

export const modifyCampaignAd = (campaign_ad) => ({
  type: MODIFY_CAMPAIGN_AD,
  payload: campaign_ad,
});
export const modifyCampaignAdSuccess = (campaign_ad) => ({
  type: MODIFY_CAMPAIGN_AD_SUCCESS,
  payload: campaign_ad,
});
export const modifyCampaignAdError = (error) => ({
  type: MODIFY_CAMPAIGN_AD_ERROR,
  payload: error,
});

// Delete Campaign Ad
export const deleteCampaignAd = (campaign_ad) => ({
  type: DELETE_CAMPAIGN_AD,
  payload: campaign_ad,
});
export const deleteCampaignAdSuccess = (campaign_ad) => ({
  type: DELETE_CAMPAIGN_AD_SUCCESS,
  payload: campaign_ad,
});
export const deleteCampaignAdError = (error) => ({
  type: DELETE_CAMPAIGN_AD_ERROR,
  payload: error,
});

export const modifyAdgroupError = (error) => ({
  type: MODIFY_ADGROUP_ERROR,
  payload: error,
});

export const duplicateAdgroup = (adgroup) => ({
  type: DUPLICATE_ADGROUP,
  payload: adgroup,
});

export const duplicateAdgroupSuccess = (adgroup) => ({
  type: DUPLICATE_ADGROUP_SUCCESS,
  payload: adgroup,
});

export const duplicateAdgroupError = (error) => ({
  type: DUPLICATE_ADGROUP_ERROR,
  payload: error,
});

export const deleteAdgroup = (adgroup) => ({
  type: DELETE_ADGROUP,
  payload: adgroup,
});

export const deleteAdgroupSuccess = (adgroup) => ({
  type: DELETE_ADGROUP_SUCCESS,
  payload: adgroup,
});

export const deleteAdgroupError = (error) => ({
  type: DELETE_ADGROUP_ERROR,
  payload: error,
});

export const resetLastCompletedAction = () => ({
  type: RESET_LAST_COMPLETED_ACTION,
});

// Create Adgroup Tracking

export const newAdgroupTracking = (adgroup) => ({
  type: NEW_ADGROUP_TRACKING,
  payload: adgroup,
});

export const newAdgroupTrackingSuccess = (adgroup) => ({
  type: NEW_ADGROUP_TRACKING_SUCCESS,
  payload: adgroup,
});

export const newAdgroupTrackingError = (error) => ({
  type: NEW_ADGROUP_TRACKING_ERROR,
  payload: error,
});

export const resetCopyScheduleToAllCampaigns = () => ({
  type: RESET_COPY_SCHEDULE_TO_ALL_CAMPAIGNS
})

export const getAccountCampaigns = () => ({
  type: GET_ACCOUNT_CAMPAIGNS,
});

export const getAccountCampaignSuccess = (account_campaigns) => ({
  type: GET_ACCOUNT_CAMPAIGNS_SUCCESS,
  payload: account_campaigns
});

export const getAccountCampaignError = (error) => ({
  type: GET_ACCOUNT_CAMPAIGNS_ERROR,
  payload: null,
});

export const getFilterVolume = (filterData) => ({
  type: GET_FILTER_VOLUME,
  payload: filterData
});

export const getFilterVolumeSuccess = (filterData) => ({
  type: GET_FILTER_VOLUME_SUCCESS,
  payload: filterData
});

export const getFilterVolumeError = (error) => ({
  type: GET_FILTER_VOLUME_ERROR,
  payload: null,
  error
});

// @payload: Object with { queryParams, time_frame_key }
export const getClickCampaignStats = (payload) => ({
  type: GET_CLICK_CAMPAIGN_STATS,
  payload: payload
})

export const getClickCampaignStatsSuccess = (campaigns, time_frame_key) => ({
  type: GET_CLICK_CAMPAIGN_STATS_SUCCESS,
  payload: campaigns,
  time_frame_key
})

export const getClickCampaignStatsError = (error) => ({
  type: GET_CLICK_CAMPAIGN_STATS_ERROR,
  payload: error,
});

export const getClickCampaignStatsById = (payload) => ({
  type: GET_CLICK_CAMPAIGN_STATS_BY_ID,
  payload,
});

export const getClickCampaignStatsByIdSuccess = (campaign, time_frame_key, queryParams, feature_flag) => ({
  type: GET_CLICK_CAMPAIGN_STATS_BY_ID_SUCCESS,
  payload: campaign,
  time_frame_key,
  queryParams,
  feature_flag
});

export const getClickCampaignStatsByIdError = (error) => ({
  type: GET_CLICK_CAMPAIGN_STATS_BY_ID_ERROR,
  payload: error,
});

export const getCallCampaignStats = (payload) => ({
  type: GET_CALL_CAMPAIGN_STATS,
  payload: payload
})

export const getCallCampaignStatsSuccess = (campaigns, time_frame_key) => ({
  type: GET_CALL_CAMPAIGN_STATS_SUCCESS,
  payload: campaigns,
  time_frame_key
})

export const getCallCampaignStatsError = (error) => ({
  type: GET_CALL_CAMPAIGN_STATS_ERROR,
  payload: error,
});

export const getCallCampaignStatsById = (payload) => ({
  type: GET_CALL_CAMPAIGN_STATS_BY_ID,
  payload,
});

export const getCallCampaignStatsByIdSuccess = (campaign, time_frame_key, queryParams, feature_flag) => ({
  type: GET_CALL_CAMPAIGN_STATS_BY_ID_SUCCESS,
  payload: campaign,
  time_frame_key,
  queryParams,
  feature_flag
});

export const getCallCampaignStatsByIdError = (error) => ({
  type: GET_CALL_CAMPAIGN_STATS_BY_ID_ERROR,
  payload: error,
});

export const getLeadCampaignStats = (payload) => ({
  type: GET_LEAD_CAMPAIGN_STATS,
  payload: payload
})

export const getLeadCampaignStatsSuccess = (campaigns, time_frame_key) => ({
  type: GET_LEAD_CAMPAIGN_STATS_SUCCESS,
  payload: campaigns,
  time_frame_key
})

export const getLeadCampaignStatsError = (error) => ({
  type: GET_LEAD_CAMPAIGN_STATS_ERROR,
  payload: error,
});

export const getLeadCampaignStatsById = (payload) => ({
  type: GET_LEAD_CAMPAIGN_STATS_BY_ID,
  payload,
});

export const getLeadCampaignStatsByIdSuccess = (campaign, time_frame_key, queryParams, feature_flag) => ({
  type: GET_LEAD_CAMPAIGN_STATS_BY_ID_SUCCESS,
  payload: campaign,
  time_frame_key,
  queryParams,
  feature_flag
});

export const getLeadCampaignStatsByIdError = (error) => ({
  type: GET_LEAD_CAMPAIGN_STATS_BY_ID_ERROR,
  payload: error,
});

export const getFilterPackages = (payload) => ({
  type: GET_FILTER_PACKAGES,
  payload: payload,
})

export const getFilterPackagesSuccess = (payload) => ({
  type: GET_FILTER_PACKAGES_SUCCESS,
  payload: payload,
})

export const getFilterPackagesError = (error) => ({
  type: GET_FILTER_PACKAGES_ERROR,
  payload: error,
})

//Get source settings
export const getCampaignsSourceSetting = (payload) => {
  return {
    type: GET_CAMPAIGNS_SOURCE_SETTINGS,
    payload: payload
  };
};

export const getCampaignSourceSettingSuccess = (campaign, campaign_id) => ({
  type: GET_CAMPAIGNS_SOURCE_SETTINGS_SUCCESS,
  payload: campaign,
  campaign_id: campaign_id
});

export const getCampaignSourceSettingError = (error) => ({
  type: GET_CAMPAIGNS_SOURCE_SETTINGS_ERROR,
  error: error,
});

// Bid multiplier change history for a single source setting (BM-8936)
export const getBidMultiplierHistory = (campaign_source_setting_id) => ({
  type: GET_BID_MULTIPLIER_HISTORY,
  payload: { campaign_source_setting_id },
});

export const getBidMultiplierHistorySuccess = (bid_multiplier_history) => ({
  type: GET_BID_MULTIPLIER_HISTORY_SUCCESS,
  payload: bid_multiplier_history,
});

export const getBidMultiplierHistoryError = (error) => ({
  type: GET_BID_MULTIPLIER_HISTORY_ERROR,
  error: error,
});

export const getActiveCampaignsForSources = (payload) => ({
  type: GET_ACTIVE_CAMPAIGNS_FOR_SOURCES,
  payload: payload,
})

export const getActiveCampaignsForSourcesSuccess = (payload) => ({
  type: GET_ACTIVE_CAMPAIGNS_FOR_SOURCES_SUCCESS,
  payload: payload,
})

export const getActiveCampaignsForSourcesError = (error) => ({
  type: GET_ACTIVE_CAMPAIGNS_FOR_SOURCES_ERROR,
  payload: error,
})


// Get default transfer number for campaign lead type id
export const getDefaultTransferNumber = (leadTypeId) => ({
  type: GET_DEFAULT_TRANSFER_NUMBER,
  payload: { lead_type_id: leadTypeId }
});

export const getDefaultTransferNumberSuccess = (data) => ({
  type: GET_DEFAULT_TRANSFER_NUMBER_SUCCESS,
  payload: data
});

export const getDefaultTransferNumberError = (error) => ({
  type: GET_DEFAULT_TRANSFER_NUMBER_ERROR,
  payload: error
});

export const setPreviousLeadTypeId = (id) => ({
  type: SET_PREVIOUS_LEAD_TYPE_ID,
  payload: id
});

// Get Ad Group Stats V4 for Quote Funnels
export const getAdGroupStatsV4 = (payload) => ({
  type: GET_AD_GROUP_STATS_V4,
  payload: payload
});

export const getAdGroupStatsV4Success = (data) => ({
  type: GET_AD_GROUP_STATS_V4_SUCCESS,
  payload: data
});

export const getAdGroupStatsV4Error = (error) => ({
  type: GET_AD_GROUP_STATS_V4_ERROR,
  payload: error
});

export const getAdGroupBidMultiplierHistory = ad_group_id => ({
  type: GET_AD_GROUP_BID_MULTIPLIER_HISTORY,
  payload: { ad_group_id },
})

export const getAdGroupBidMultiplierHistorySuccess = bid_multiplier_history => ({
  type: GET_AD_GROUP_BID_MULTIPLIER_HISTORY_SUCCESS,
  payload: bid_multiplier_history,
})

export const getAdGroupBidMultiplierHistoryError = error => ({
  type: GET_AD_GROUP_BID_MULTIPLIER_HISTORY_ERROR,
  error,
})
